import React from "react"
import styled from "@emotion/styled"
import {
  type FloatingArrowProps,
  FloatingArrow as _FloatingArrow,
  offset,
} from "@floating-ui/react"

const FloatingArrow = styled(_FloatingArrow)`
  fill: var(--floating-bg);
`

const ARROW_HEIGHT = 5
const ARROW_WIDTH = ARROW_HEIGHT * 2

/**
 * The default arrow for floating elements to use.
 *
 * This should be the first child in a floating element.
 * The fill color can be configured with a `--floating-bg` css variable on the floating element.
 */
export const Arrow = (
  props: Pick<FloatingArrowProps, "context" | "staticOffset"> & {
    ref: React.RefObject<SVGSVGElement | null>
  }
) => {
  return (
    <FloatingArrow
      ref={props.ref}
      context={props.context}
      staticOffset={props.staticOffset}
      width={ARROW_WIDTH}
      height={ARROW_HEIGHT}
    />
  )
}

const BASE_TOOLTIP_ARROW_OFFSET = ARROW_HEIGHT

/**
 * useFloating middleware to offset the floating element for the arrow.
 *
 * Without this the arrow is placed on top of the reference element.
 */
export const arrowOffset = () => offset(BASE_TOOLTIP_ARROW_OFFSET)
